import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white px-4 py-20" data-id="element-90" data-mp="1o2vfqkp72f4g">
      <motion.div initial={{
      opacity: 0,
      scale: 0.96
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="relative mx-auto max-w-4xl overflow-hidden rounded-3xl border border-[#E7D7B6] bg-[#FFFCF5] p-8 text-center shadow-[0_8px_24px_rgba(16,42,67,.07)] sm:p-12" data-id="element-91" data-mp="223em7ne0hd4i">
        <div className="absolute left-0 top-0 h-1 w-full bg-gold" data-id="element-92" data-mp="1j4ka6m5xmqs1" />
        <ShieldCheck className="mx-auto mb-6 rounded-full bg-[#F8F0DA] p-5 text-gold-dark" size={90} data-id="element-93" data-mp="1j5vbmfbwnmfz" />
        <h2 className="font-serif text-3xl font-bold text-navy" data-id="element-94" data-mp="qo9eu62xqqek">
          Garantía total de 7 días
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-5 leading-relaxed text-ink" data-id="element-95" data-mp="lpogkc78ugsr">
          <p data-id="element-96" data-mp="ozjfev315uuf">
            Abre los 8 tomos. Revisa los 4 bonos. Úsalos en tu clase más difícil
            esta semana.
          </p>
          <p className="font-medium text-navy" data-id="element-97" data-mp="txkvr892ng27">
            Si sientes que el material no te ahorró horas de trabajo:
          </p>
          <p className="text-xl font-bold text-green-dark" data-id="element-98" data-mp="yq4h4re03fhk">
            Te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios.
            Sin complicaciones.
          </p>
          <p className="text-sm text-slate-500" data-id="element-99" data-mp="628ez75nwvde">
            Si el material no te da el valor que prometemos, no queremos
            quedarnos con tu dinero.
          </p>
        </div>
      </motion.div>
    </section>;
}